import Davinci1 from '../Davinci/Davinci (1).webp'
import Davinci2 from '../Davinci/Davinci (2).webp'
import Davinci3 from '../Davinci/Davinci (3).webp'
import Davinci4 from '../Davinci/Davinci (4).webp'
import Davinci5 from '../Davinci/Davinci (5).webp'
import Davinci6 from '../Davinci/Davinci (6).webp'
import Davinci7 from '../Davinci/Davinci (7).webp'





const Davinciimages =[
Davinci1,Davinci2,Davinci3,Davinci4,Davinci5,Davinci6,Davinci7
]

export default Davinciimages;